// extracted by mini-css-extract-plugin
module.exports = {"sectionSpacer":"JobContactSection-module-section-spacer","questionContainer":"JobContactSection-module-question-container","jobsHeadline":"JobContactSection-module-jobs-headline"};